
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"143","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M116.835 49.848h8.912V.17h-8.912v49.678zm-99.096.004C8.166 50.051.112 42.036.31 32.697c-.198-9.34 7.922-17.288 17.495-17.09 9.572-.132 17.758 7.75 17.56 17.09.198 9.34-8.054 17.354-17.626 17.155zm.066-8.213c4.819 0 8.45-3.776 8.45-8.876s-3.631-9.008-8.45-9.008c-4.951 0-8.45 3.775-8.45 9.008 0 5.1 3.498 8.876 8.45 8.876zm36.516 8.28c-5.744 0-10.563-2.385-13.534-6.36l4.49-5.43c2.838 2.98 5.941 4.437 9.176 4.437 2.376 0 4.159-.927 4.159-2.716 0-1.39-.924-1.92-3.367-2.98l-3.499-1.457c-6.007-2.451-8.912-5.167-8.912-10.002 0-6.16 4.885-9.803 12.015-9.803 4.885 0 8.78 1.656 11.751 4.901l-4.49 5.498c-2.178-2.054-4.62-3.113-7.327-3.113-2.179 0-3.499.795-3.499 2.318 0 1.259.858 1.855 3.433 2.914l3.169 1.325c6.337 2.583 9.176 5.167 9.176 10.002 0 3.245-1.188 5.829-3.63 7.683-2.378 1.855-5.414 2.782-9.111 2.782zm19.066-17.222c-.197 9.34 7.856 17.354 17.429 17.155 9.572.199 17.824-7.816 17.626-17.155.198-9.34-7.988-17.222-17.56-17.09-9.573-.198-17.692 7.75-17.495 17.09zm25.945.066c0 5.1-3.631 8.876-8.45 8.876-4.951 0-8.45-3.776-8.45-8.876 0-5.233 3.499-9.008 8.45-9.008 4.819 0 8.45 3.908 8.45 9.008zm38.624 16.843a13.054 13.054 0 004.429-4.445 2.186 2.186 0 000-2.235 13.036 13.036 0 00-4.423-4.453 2.156 2.156 0 00-2.237 0 12.986 12.986 0 00-4.429 4.442 2.16 2.16 0 000 2.246 13.013 13.013 0 004.422 4.445 2.163 2.163 0 002.238 0z","fill":"#132540"}})])
          )
        }
      }
    